import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NoResultsComponent } from './no-results.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';

@NgModule({
  declarations: [
    NoResultsComponent
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatCardModule
  ],
  exports: [
    NoResultsComponent
  ]
})
export class NoResultsComponentModule {}
